import { optionSchema } from '@/common/schemas/option.schema'
import z from 'zod'

export const contractEnvelopeSchema = z.object({
  contract_attributes: z
    .object({
      valid_envelope_attributes: z
        .object({
          contractee_attributes: z
            .object({
              signable_id: optionSchema.optional(),
            })
            .optional(),
          contractor_attributes: z
            .object({
              signable_id: optionSchema.optional(),
            })
            .optional(),
          surety_attributes: z
            .object({
              signable_id: optionSchema.optional(),
            })
            .optional(),
        })
        .optional(),
    })
    .optional(),
})

export type ContractEnvelopeValidationSchema = z.infer<typeof contractEnvelopeSchema>

export const contractEnvelopeWitnessSchema = z.object({
  contract: z.object({
    valid_envelope: z.object({
      witnesses: z.object({
        full_name: z.string().trim().min(1, 'Campo Nome é obrigatório'),
        email: z.string().trim().min(1, 'Campo e-mail é obrigatório').email('Use um formato de e-mail válido'),
        cpf: z.string().trim().min(1, 'Campo CPF é obrigatório').min(14, 'Use um CPF válido'),
        birthday: z
          .string()
          .trim()
          .min(1, 'Campo obrigatório')
          .refine(
            (data) => {
              if (data.length < 10) return false
              const year = Number(data.split('/')[2])
              const currentYear = new Date().getFullYear()
              const difference = currentYear - year
              if (difference < 10 || difference > 200) return false
              return true
            },
            { message: 'Use uma data válida' },
          ),
      }),
    }),
  }),
})

export type ContractEnvelopeWitnessValidationSchema = z.infer<typeof contractEnvelopeWitnessSchema>

export const cancelContractEnvelopeSchema = z.object({
  invalidating_reason: z.string({ message: 'Campo obrigatório' }).trim().min(1, { message: 'Campo obrigatório' }),
})

export type CancelContractEnvelopeValidationSchema = z.infer<typeof cancelContractEnvelopeSchema>
